import { BlobServiceClient } from '@azure/storage-blob';
import GoalServices from './goal.services';
import { v4 as uuidv4 } from 'uuid';

export class WoboFileUploadService {
  client = null;
  publicContainer = null;
  static errorCodes = [422, 500, 403, 404];
  missingContainer = {
    errorId: 'Missing Container',
    errorMessage: 'Public container for upload was not provided',
  }

  constructor(sasToken) {
    this.client = new BlobServiceClient(sasToken);
    this.publicContainer = this.client.getContainerClient('');
    this.upload = this.upload.bind(this);
  }

  // Upload the file to temp location
  async upload(file) {
    if (!this.publicContainer) {
      return this.missingContainer;
    }
    const filename = this.generateFileName(file.name);
    const blobClient = await this.publicContainer.getBlockBlobClient(filename);
    try {
      const response = await blobClient.uploadData(file);
      if (response._response.status > 299) {
        return {
          errorId: response._response.status.toString(),
          errorMessage: response.errorCode || 'Unknown Error',
        }
      }
      return filename;
    } catch (err) {
      console.log(err)
      toastr.error(err?.toString() || `Network error occured while trying to upload.`);
      return {
        errorId: 'Failed To Upload',
        errorMessage: 'Network error occured while trying to upload',
      }
    }
  }

  // Delete the file from container
  static async delete(signature) {
    const fetchConfig = {
      method: 'delete',
    }
    let _res = await fetch(
      `${wbConfig.baseUrl}/vnext/fus/api/v1/delete-file/${signature}`,
      fetchConfig
    )
    _res = await _res.json();
    const { status } = _res;
    if ( this.errorCodes.indexOf(status) > -1 ) {
      toastr.error(_res?.message || `Something went wrong, please try again later.`);
      throw new Error(_res?.message)
    }
    return _res
  }

  // Download the file from container
  static async download(url) {
    const fetchConfig = {
      method: 'get',
      headers: {
        'x-ambassador-stream': true
      }
    }
    const _res = await fetch(`${url}`, fetchConfig)
    const { status } = _res;
    if ( this.errorCodes.indexOf(status) > -1 ) {
      toastr.error(_res?.message || `Something went wrong, please try again later.`);
      throw new Error(_res?.message);
    }
    return _res;
  }

  // Get the file details
  static async getFileDetails(signature) {
    try {
      const fetchConfig = {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
        },
      }
      let _res = await fetch(
        `${wbConfig.baseUrl}/vnext/fus/api/v1/file-status/${signature}?appInID=woboclient&userId=8orgId=8`,
        fetchConfig
      )
      _res = await _res.json()
      return _res
    } catch (error) {
      console.log(error)
    }
  }

  // Generating the SAS token to upload the file
  static async generateSasToken({
    appinID,
    request_id,
    accessToken,
    userId,
    orgId,
  }) {
    const fetchConfig = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ appinID, request_id, userId, orgId }),
    }
    let _res = await fetch(
      `${wbConfig.baseUrl}/vnext/fus/api/v1/sastoken`,
      fetchConfig
    )
    const { status } = _res;
    if ( this.errorCodes.indexOf(status) > -1 ) {
      toastr.error(_res?.message || `Something went wrong, please try again later.`);
      throw new Error(_res?.message)
    }
    _res = await _res.json()
    return _res
  }

  generateFileName(orginalName) {
    if (!orginalName) {
      return null
    }
    const filename = uuidv4();
    const ext = orginalName.toString().substr(orginalName.lastIndexOf('.'))
    return `FUSWOBO_${filename}${ext}`
  }

  static async processFile(fileObj) {
    const fetchConfig = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(fileObj),
    }
    let _res = await fetch( `${wbConfig.baseUrl}/vnext/fus/api/v1/process-file`, fetchConfig );
    const { status } = _res;
    _res = await _res.json();

    if ( this.errorCodes.indexOf(status) > -1 ) {
      toastr.error(_res?.message || `Something went wrong, please try again later.`);
      throw new Error(_res?.message)
    }
    return _res
  }
}

export const generateSASAnduploadToTempLocation = async (
  file,
  { appinID, request_id, accessToken, userId, orgId }
) => {
  try {
    const tokenDetails = await WoboFileUploadService.generateSasToken({
      appinID,
      request_id,
      accessToken,
      userId,
      orgId,
    })
    const uploadInstance = new WoboFileUploadService(tokenDetails.url)
    const newFilename = await uploadInstance.upload(file)
    return newFilename
  } catch (error) {
    console.error(error)
    return false
  }
}

export const pollUpdatedUserProfileFileStatus = async ({profileReload, coverReload}, delayMs) => {
  try {
    let services = new GoalServices();
      const clearTimer = setInterval(async () => {
        services
        .getFileStatus({ profileReload, coverReload })
          .then((response) => {
            const jsonData = response?.data
            if (jsonData) {
              if (
                jsonData?.resp?.reload == 1
              ) {
                clearInterval(clearTimer);
                removeLoaderWidget();
                location.reload();
              }
            }
          })
        .catch((err) => {})
      },delayMs)
  } catch (error) {
    removeLoaderWidget();
  }
}

export const pollFileStatus = async ({profileReload, coverReload, signature}, delayMs, timeout) => {
  try {
    let services = new GoalServices();
    return new Promise((resolve, reject)=>{
      const clearTimer = setInterval(async () => {
        services
          .getFileStatus({ profileReload, coverReload, signature })
          .then((response) => {
            const jsonData = response?.data
            if (jsonData?.resp?.path) {
              clearInterval(clearTimer)
              return resolve(jsonData)
            }
          })
      }, delayMs);

      if (timeout) {
        setTimeout(() => {
          clearInterval(clearTimer);
          reject(new Error("Timeout: polling the file details."))
        }, timeout);
      }
    })
  } catch (error) {
    reject(new Error("Error: polling the file details."))
    removeLoaderWidget();
  }
}

export const updateMemberProfileAndCover = async (file, saveUrl, options, isCropped, saveOptions) => {
  generateSASAnduploadToTempLocation(file, options).then((newFilename) => {
    if (newFilename) {
      const fileName = createFilename(file.name);
      const prefix = `FUSPROF_${options.request_id}`;
      const targetFolderName = uuidv4();
      let callBackType = 3;
      if (saveOptions?.coverReload) {
        callBackType = 2;
      }
      const fileDetails = {
        source_fileName: newFilename,
        file_mimetype: file.type || 'image/jpeg',
        file_size: file.size,
        request_id: options.request_id,
        signature: prefix,
        isCropped: isCropped,
        isPublic: true,
        appInID: options.appinID, // Client app id and the same name for client container in the azure
        byok_tenant_id : "", // this is the tenant id for encrypting the file with
        file_originalname: fileName, // Name of the file
        webhook_details:{
            "host":`${wbConfig.baseDomainUrl}/fus/fusCallback?type=${callBackType}`,
            "path":"",
        }, 
        orgId : options?.orgId, // Organization id
        userId : options?.profileUserId, // User id of the requested user
        target_folder: targetFolderName, // Name of the target folder inside the target container,
      }

      WoboFileUploadService.processFile(fileDetails).then((response)=>{
        if (saveOptions?.profileReload || saveOptions?.coverReload) {
          pollUpdatedUserProfileFileStatus(saveOptions, 15000);
        }
      })
    }
  })
}

const uploadFile = async (file, options) => {
  const {
    appInID = 'woboclient', // Client app id and the same name for client container in the azure
    requestId = uuidv4(), // Unique request id (uuid)
    targetFolder = uuidv4(), // Name of the target folder inside the target container,
    userId = window.uData?.user_id,
    orgId = window.uData?.org_id,
    processOptions = {},
    pollInterval = 5000,
    requestTimeout = 60000
  } = options || {};

  const newFilename = await generateSASAnduploadToTempLocation(file, {
    appinID: appInID,
    request_id: requestId,
    userId,
    orgId
  })
    
  file.sourceFileName = newFilename;
  const fileDetails = {
    source_fileName: file.sourceFileName,
    file_mimetype: file.type || 'image/jpeg',
    file_size: file.size,
    request_id: requestId,
    signature: `FUS_${requestId}`,
    isCropped: false,
    isPublic: true,
    appInID, // Client app id and the same name for client container in the azure
    byok_tenant_id: '', // this is the tenant id for encrypting the file with
    file_originalname: file.name, // Name of the file
    webhook_details: {
      host: `${wbConfig.baseDomainUrl}/fus/fusCallback?type=1`,
      path: '',
    },
    orgId, // Organization id
    userId, // User id of the requested user
    target_folder: targetFolder, // Name of the target folder inside the target container,
    ...processOptions
  }

  await WoboFileUploadService.processFile(fileDetails);
  await pollFileStatus({
    signature: fileDetails.signature
  }, pollInterval, requestTimeout);
  const imgSrc = `${wbConfig.baseDomainUrl}/fus/GetFileData?signature=${fileDetails.signature}`;

  return {
    url: imgSrc,
  };
}

window.FUS = {
  WoboFileUploadService,
  generateSASAnduploadToTempLocation,
  pollFileStatus,
  uploadFile
}